import React from 'react'

import cgdreamLogo from 'images/cgdream_RGB_white.svg'
import bannerImgSm from 'images/design_partnership/cgdream_hero_small.webp'

import Layout from './Components/Layout'

const heading = (
  <img src={cgdreamLogo} alt="CGDream.ai" className="cgt-banner__logo" />
)

const content = (
  <p className="cgt-legacy-text-default cgt-legacy-text-default--dark-bg">
    CGDream.ai is a cutting-edge, AI-driven image generator developed by CGTrader,
    designed to transform user ideas into visual realities. It allows you to create
    images from text, images or 3D models.
  </p>
)

const action = (
  <button className="cgt-button cgt-button--primary new-banner__cta">
    Try it Now!
  </button>
)

const cgdreamLink = 'https://cgdream.ai/?utm_source=cgtrader&utm_medium=referral&utm_campaign=mymodels'

function CgdreamBanner() {
  return (
    <div
      className="new-banner"
      style={{
        backgroundImage: `url("${bannerImgSm}")`
      }}
    >
      <Layout
        heading={heading}
        content={content}
        action={action}
      />
      <a
        href={cgdreamLink}
        className="new-banner__link"
        target="_blank"
        rel="noopener noreferrer"
      />
    </div>
  )
}

export default CgdreamBanner
